import { Navigate } from "react-router-dom";
import { getKind } from "@/lib/api";

export default function RequireAuth({ kind, children }) {
  const token = localStorage.getItem("gtarp_token");
  const currentKind = getKind();
  if (!token || currentKind !== kind) {
    return <Navigate to={kind === "owner" ? "/owner/login" : "/creator/login"} replace />;
  }
  return children;
}
